module.exports = __webpack_public_path__ + "static/1191275124.585b7592.jpg";